const WHITE_LIST_MIME_IMAGE = [
  'image/jpeg', // .jpeg .jfif, .jfif-tbnl, .jpe, .jpg - JPEG
  'image/png', // .png - PNG
  'image/bmp', // .bmp - Generic Bitmap
  'image/x-ms-bmp', // .bmp - Microsoft Bitmap
  'image/heic', // .heic - heic
  'image/svg+xml',  // .svg
  'image/webp' // .webp	WEBP image
];

const WHITE_LIST_MIME_VIDEO = [
  'video/x-flv', // .flv - Flash
  'video/mp4', // .mp4 - MPEG-4
  'video/mpeg', // .mp4 .mpe .mpeg .mpg
  'video/quicktime', // .mov .qt - QuickTime
  'video/x-ms-asf', // .asf - Microsoft Advanced Systems Format (ASF)
  'video/x-msvideo', // .avi - A/V Interleave
  'video/x-sgi-movie', // .movie
  'video/x-m4v', // .m4v
  'video/x-dv', // .dv
  'video/mp2t', // .m2ts - Blu-ray Disc Audio-Video (BDAV) MPEG-2 Transport Stream
  'video/MP2T', // .ts - iPhone Segment
  'video/3gpp', // .3gp - 3GP Mobile
  'video/x-ms-wmv', // .wmv - Microsoft Windows Media Video
  'video/webm' // .webm WEBM video
];

const WHITE_LIST_MIME_AUDIO = [
  'audio/aac', // AAC audio
  'audio/midi', 'audio/x-midi', // .mid .midi	Musical Instrument Digital Interface
  'audio/mpeg', // MP3 audio
  'audio/ogg', // OGG audio
  'audio/opus', // .opus	Opus audio
  'audio/wav', // .wav	Waveform Audio Format
  'audio/webm', // .weba	WEBM audio
];
  
const WHITE_LIST_MIME_FILE_DOCS = [
  'application/msword', // .doc	Microsoft Word
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document', //.docx	Microsoft Word (OpenXML)
  'application/vnd.oasis.opendocument.text', // .odt OpenDocument text document
];

const WHITE_LIST_MIME_FILE_PRESENTATION = [
  'application/vnd.ms-powerpoint', // .ppt	Microsoft PowerPoint
  'application/vnd.openxmlformats-officedocument.presentationml.presentation', // .pptx	Microsoft PowerPoint (OpenXML)
  'application/vnd.oasis.opendocument.presentation', // .odp	OpenDocument presentation document
];

const WHITE_LIST_MIME_FILE_SHEET = [
  'application/vnd.ms-excel', // .xls	Microsoft Excel
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',  // .xlsx	Microsoft Excel (OpenXML)
  'application/vnd.oasis.opendocument.spreadsheet', // .ods	OpenDocument spreadsheet document
];

const WHITE_LIST_MIME_FILE_TEXT = [
  'text/plain', // .txt	Text, (generally ASCII or ISO 8859-n)
];

const WHITE_LIST_MIME_PDF = [
  'application/pdf', // .pdf	Adobe Portable Document Format (PDF)
];

const WHITE_LIST_MIME_CODE = [
  'text/css', // .css	Cascading Style Sheets (CSS)
  'text/html', // .htm .html	HyperText Markup Language (HTML)
  'text/javascript', // .js	JavaScript
];

const WHITE_LIST_MIME_FILE_ARCHIVE = [
  'application/x-bzip',   // .bz	BZip archive
  'application/x-bzip2',  // .bz2	BZip2 archive
  'application/epub+zip', // .epub	Electronic publication (EPUB)
  'application/gzip',     // .gz	GZip Compressed Archive
  'application/vnd.rar',  // .rar	RAR archive
  'application/x-tar',    // .tar	Tape Archive (TAR)
  'application/zip',      // .zip	ZIP archive
  'application/x-7z-compressed' // .7z	7-zip archive
];

/**
 * Covert bytes to human-readable format
 * @param {number} bytes - Size in bytes
 * @param {number} [dec=2] - Number of decimal places
 * @returns {string} - Human-readable size
 */
export const formatBytes = (bytes, dec = 2) => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${(bytes / Math.pow(k, i)).toFixed(dec)} ${sizes[i]}`;
};

/**
 * Convert KB to MB
 * @param {number} kb - Size in KB
 * @returns {number} - Size in MB
 */
export const convertKBtoMB = (kb) => {
  return (kb / 1024).toFixed(2);
};


export {
  WHITE_LIST_MIME_IMAGE,
  WHITE_LIST_MIME_AUDIO,
  WHITE_LIST_MIME_VIDEO,

  WHITE_LIST_MIME_FILE_DOCS,
  WHITE_LIST_MIME_FILE_PRESENTATION,
  WHITE_LIST_MIME_FILE_SHEET,

  WHITE_LIST_MIME_FILE_TEXT,
  WHITE_LIST_MIME_FILE_ARCHIVE,
  WHITE_LIST_MIME_PDF,
  WHITE_LIST_MIME_CODE
}